$(function () {
  const isPax = $('body').attr('is_pax') == 1;
  const terminalUniqueId = $('body').attr('t_serial_number');
  const poiid = $('body').attr('t_poiid');

  if (isPax) {
    if (poiid) {
      passTerminalDataToWebView({
        action: 'pax',
        data: {
          action: 'login',
          data: {
            poiid: poiid.toUpperCase(),
          },
        },
      });
    }
  }

  $(document).on('submit', '#pax-poiid-form', function (e) {
    e.preventDefault();
    const poiid = $('#pax-poiid-input').val();

    if (poiid) {
      passTerminalDataToWebView({
        action: 'pax',
        data: {
          action: 'login',
          data: {
            poiid: poiid.toUpperCase(),
          },
        },
      });
    }
  });
});
